import { render, staticRenderFns } from "./ForeignInfoCollection.vue?vue&type=template&id=a87e3024&scoped=true&"
import script from "./ForeignInfoCollection.vue?vue&type=script&lang=js&"
export * from "./ForeignInfoCollection.vue?vue&type=script&lang=js&"
import style0 from "./ForeignInfoCollection.vue?vue&type=style&index=0&id=a87e3024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87e3024",
  null
  
)

export default component.exports